import { isEqual } from 'lodash'
import { _getPDataById, getPersonListData } from '../persons/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { ITsdContact } from '~/types/contact/models'
import {
  ResourceUseIds,
  getResourceUseById, // Leave this here. Needed for testing.
} from '~/services/selectLists/resourceUses'

const tsdContactListData = undefined as unknown as ITsdContact[]

export const getTsdContactListData = getListDataFunctionFactory<ITsdContact[]>({
  listData: tsdContactListData,
  storageKey: 'tsdcontacts',
  getStartingListData: getStartingTsdContactListData,
  sortFunction: (a, b) =>
    a.person.name.lastName > b.person.name.lastName ? 1 : -1,
})

export function _getTCTDataById(
  id: TEntityId,
  list: ITsdContact[]
): ITsdContact {
  if (!list) {
    throw new Error(`_getTCTDataById called with undefined/null list`)
  }
  const companyContact = list.find((cct: ITsdContact) => cct.id === id)
  if (!companyContact) {
    throw new Error(`Can't find tsdContact '${id}'`)
  }
  return companyContact
}

export async function getTsdContactDataById(
  id: TEntityId
): Promise<ITsdContact> {
  const list = await getTsdContactListData()
  if (!list) {
    throw new Error(`getTsdContactList returned undefined/null`)
  }
  const tc = list.find((tsdContact: ITsdContact) => tsdContact.id === id)
  if (!tc) {
    throw new Error(`Can't find tsdContact '${id}'`)
  }
  return tc
}

export async function getTsdContactListDataByTsdId(id: string) {
  const list = await getTsdContactListData()
  return list.filter((tsdContact: ITsdContact) =>
    isEqual(tsdContact.tsd?.id, id)
  )
}

export async function getTsdContactListDataWithUseForRegistrationByTsdId(
  id: string
) {
  const list = await getTsdContactListData()
  return list.filter(
    (tsdContact: ITsdContact) =>
      isEqual(tsdContact.tsd?.id, id) &&
      tsdContact.useFor?.find((uf) => uf.id === ResourceUseIds.REGISTRATIONS)
  ) as ITsdContact[]
}

export async function getStartingTsdContactListData(): Promise<ITsdContact[]> {
  const pList = await getPersonListData()
  return [
    {
      id: 'XXTCT0001',
      hrid: 'TCT0001',
      person: _getPDataById('XXPE0026', pList),
      phone: '(510) 341-7777',
      cell: '(555) 999-8862',
      email: 'mickey@intelisys.com',
      tsd: {
        id: 'XXT0002',
        label: 'Intelisys',
      },
      role: { id: 'XXTCR003', label: 'Channel Manager' },
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXTCT0002',
      hrid: 'TCT0002',
      person: _getPDataById('XXPE0027', pList),
      phone: '(555) 343-3222',
      cell: '(555) 999-8861',
      email: 'babe@tbi.com',
      tsd: {
        id: 'XXT0001',
        label: 'TBI',
      },
      role: { id: 'XXTCR003', label: 'Channel Manager' },
      // useFor: [getResourceUseById(ResourceUseIds.REGISTRATIONS)], // for testing
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXTCT0003',
      hrid: 'TCT0003',
      person: _getPDataById('XXPE0018', pList),
      phone: '(510) 343-3222',
      cell: '(555) 999-8860',
      email: 'meryl@wxtechnologygroup.com',
      tsd: {
        id: 'XXT0003',
        label: 'WXTG',
      },
      role: { id: 'XXTCR003', label: 'Channel Manager' },
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: false,
    },
  ]
}
